<template>
  <div class="grade_detil">
    <Breadcrumb></Breadcrumb>
    <div class="title">
      {{title}}
      <a href="javascript:;" class="change-btn" @click="deriveExport">导出成绩单</a>
    </div>
    <table>
      <tr>
        <th v-for="val in tableHeader" :key="val">{{val}}</th>
      </tr>
      <tr v-for="(item,index) in table" :key="index">
        <td>{{item.code}}</td>
        <td>{{item.studentName}}</td>
        <td v-for="val in item.subject" :key="val.id">{{val.score}}</td>
        <td v-if="Points">{{item.totalPoints}}</td>
        <td v-for="val in item.cus" :key="val.id">{{val.customValue}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import { scoreQueryList,scoreExport } from '@/api/common_api'

import moment from 'dayjs'
import { Breadcrumb } from '@/components'

export default {
  components: {
    Breadcrumb
  },
  data() {
    return {
      title:this.$route.query.title!='undefined'?this.$route.query.title:this.$route.query.name,
      transcriptId:this.$route.query.id,
      tableHeader:['学号','姓名'],
      table:[],
      Points:false
    };
  },
  created() {
    this.getList()
  },
  methods: {
    getList(){
      scoreQueryList({transcriptId:this.transcriptId}).then(res=>{
        if(res.s==1){
          let data = res.d.studentScore
          data[0].subject.forEach(element => {
            this.tableHeader.push(element.subjectName)
          });
          if(data[0].hasOwnProperty('totalPoints')){
            this.tableHeader.push('总分')
            this.Points = true
          }
          data[0].cus.forEach(element => {
            this.tableHeader.push(element.customName)
          });
          this.table = data
        }
      })
    },
    deriveExport(){
      scoreExport({id:this.transcriptId}).then(res=>{
        if(res.s == 1){
          this.$message({
            message: '导出文件成功',
            type: 'success'
          })
          this.$notify({
            title: `导出文件成功`,
            type: 'success',
            dangerouslyUseHTMLString: true,
            duration: 3000,
            offset: 60,
            message: `<iframe src='${window.location.origin+res.d.filePath}' style="display:none"></iframe>`
          })
        }else{
          this.$message.error(res.d)
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
.grade_detil{
  padding: 0 14Px 37Px;
  background: #fff;
  .title{
    color: #191919;
    text-align: center;
    overflow: hidden;
    font-size: 14Px;
    line-height: 32Px;
    margin: 17Px 0 9Px;
    padding-left: 80Px;
    .change-btn{
      float: right;
      height: 32Px;
      line-height: 32Px;
    }
  }
  table{
    width: 100%;
    color: #535353;
    font-size: 14Px;
    border: 1Px solid #E4E4E4;
    th{
      border: 1Px solid #E4E4E4;
      background: #f1f5f6;
      height: 32Px;
    }
    td{
      border: 1Px solid #E4E4E4;
      text-align: center;
    }

  }
}
</style>
